import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {User} from "src/app/model/User";
import ApiEndpoint from "../ApiEndpoint";
import {Observable} from "rxjs";

@Injectable({
  providedIn: "root"
})
export class UserService {
  //
  // system = ['radd','redit','rdct','uadd','uedit','udct']
  // super = ['upd']
  // permission = []

  currentId: any;

  constructor(private httpClient: HttpClient) {
  }

  //
  // loadPermission(roles:any[]){
  //   this.permission= []
  //   roles.forEach((v,i)=>{
  //     if(v.toLowerCase().includes('super')) [...this.permission, ...this.super];
  //     else if(v.toLowerCase().includes('system'))  [...this.permission, ...this.system];
  //   })
  //   // this.permission.filter((v,i)=> v!=v);
  //   localStorage.setItem('permission',JSON.stringify(this.permission))
  // }

  updateUserStatus(user) {
    // return this.httpClient.post(`${ApiEndpoint.baseURL}/user/update`, user);

    return this.httpClient.post(
      `${ApiEndpoint.baseURL}/user/update/status?userId=${user.id}&status=${user.status}&reason=${user.reason}`,
      {}
    );
  }

  approveUser(id, status, reason) {
    return this.httpClient.post(
      `${ApiEndpoint.baseURL}/user/status?tempId=${id}&status=${status}&reason=${reason}`,
      {}
    );
  }

  getUsers(status) {
    return this.httpClient.get<User[]>(`${ApiEndpoint.baseURL}/user/list`, {
      params: {status}
    });
  }
  getRoles(status?) {
    return this.httpClient.get(`${ApiEndpoint.baseURL}/role/active`);
  }

  approvalPendingList() {
    return this.httpClient.get(`${ApiEndpoint.baseURL}/user/newUser`);
  }
  getTeamList(){
    return this.httpClient.get(`${ApiEndpoint.baseURL}/user/team/list`);
  }
  getOrganizationTeamList(){
    return this.httpClient.get(`${ApiEndpoint.baseURL}/user/organization/team/list`);
  }
  getUserOrganizationTeam(id){
    return this.httpClient.post(`${ApiEndpoint.baseURL}/user/organization/team`,id);
  }

  // login(user) {
  //   let qParams = "";
  //   const keys = Object.keys(user);
  //   Object.keys(user).forEach((k, i) => {
  //     qParams += `${k}=${user[k]}`;
  //     if (i < Object.keys(user).length - 1) {
  //       qParams += "&";
  //     }
  //   });
  //   console.log("================================");
  //   return this.httpClient.post(
  //     `${ApiEndpoint.OAUTH_TOKEN}?${qParams}`,
  //     {},
  //     {
  //       headers: {Authorization: `Basic ${btoa("client:secret")}`}
  //     }
  //   );
  // }

  // login(user) {
  //   // let qParams = "";
  //   // const keys = Object.keys(user);
  //   // Object.keys(user).forEach((k, i) => {
  //   //   qParams += `${k}=${user[k]}`;
  //   //   if (i < Object.keys(user).length - 1) {
  //   //     qParams += "&";
  //   //   }
  //   // });
  //   // return this.httpClient.post(
  //   //   `${ApiEndpoint.OAUTH_TOKEN}?${qParams}`,
  //   //   {},
  //   //   {
  //   //     headers: {Authorization: `Basic ${btoa("client:secret")}`}
  //   //   }
  //   // );
  //   const headers = {'Authorization': `Basic ${btoa("client:secret")}`,'Content-type': 'application/x-www-form-urlencoded'};
  //   let param = new HttpParams().set('username', user.username).set('password', user.password).set('grant_type', user.grant_type);
  //   return this.httpClient.post(`${ApiEndpoint.OAUTH_TOKEN}`,param,{headers});
  // }

  login(user) {
    // console.log(`${ApiEndpoint.OAUTH_TOKEN}`);
    const headers = {'Authorization': `Basic ${btoa('clnt@Vanguard@360@ML:scrt@G@67cB@Lk321ML@360')}`} // prod
    // const headers = {'Authorization': `Basic ${btoa('web:webpass')}`} //UAT
    return this.httpClient.post(`${ApiEndpoint.OAUTH_TOKEN}`,{username:user.username, password:user.password, grant_type:user.grant_type},{headers});
  }


  userDetail(user) {
    return this.httpClient.get(`${ApiEndpoint.baseURL}/user/info`);
  }

  getUserById(userId: number) {
    return this.httpClient.get(
      `${ApiEndpoint.baseURL}/user/findById/${userId}`
    );
  }

  updateUser(user: any) {
    return this.httpClient.post(`${ApiEndpoint.baseURL}/user/update`, user);
    // return this.httpClient.post(`${ApiEndpoint.baseURL}/file/uploadUserProfile`, user);
  }

  addUser(user: User) {
    return this.httpClient.post(`${ApiEndpoint.baseURL}/user/add`, user);
  }

  getUserRegion(id) {
    return this.httpClient.get(`${ApiEndpoint.baseURL}/region/user/${id}`);
  }

  checkUniqueLoginId(id) {
    return this.httpClient.get(`${ApiEndpoint.baseURL}/user/checkExistOrNot?userLogId=${id}`)
  }

  saveUserImage(image) {
    return this.httpClient.get(
      `${ApiEndpoint.baseURL}/file/uploadUserProfile`,
      image
    );
  }

  resetPassword(currentPassword, newPassword, confirmPassword) {
    return this.httpClient.post(`${ApiEndpoint.baseURL}/user/changePassword`,
      {
        currentPassword: currentPassword,
        newPassword: newPassword,
        confirmPassword: confirmPassword
      })
  }

  imageUpload(loginid, tempid, file) {
    return this.httpClient.post(`${ApiEndpoint.baseURL}/file/upload?id=${loginid}&tempId=${tempid}`, file)
  }

  getUserImage(path:string){
    return this.httpClient.get(`${ApiEndpoint.baseURL}/file/download?filePath=${path}`,{ responseType: 'blob' })
  }

  recoverPassword(body) {
    return this.httpClient.post(`${ApiEndpoint.baseURL}/user/forgetPassword`, body)
  }

  userEditedinfo(id) {
    return this.httpClient.get(`${ApiEndpoint.baseURL}/user/editHistory?tempId=${id}`,)
  }

  getCaoList(list: any[]) {
    if (list.length) {
      return this.httpClient.get(`${ApiEndpoint.baseURL}/user/listOfCao?regionId=${list}`)
    }
    return this.httpClient.get(`${ApiEndpoint.baseURL}/user/listOfCao`)
  }

  validatePassword(password) {
    return this.httpClient.get(`${ApiEndpoint.baseURL}/user/validatePassword?password=${password}`)
  }

  revokeToke(){
    return this.httpClient.get(`${ApiEndpoint.oauthBaseURL}/logout/revoke-token`, {responseType:'text'})
  }
  getInvolvement(obj):Observable<any> {
    return this.httpClient.post(`${ApiEndpoint.baseURL}/investigation/check/involvement`, obj);
  }

}
